import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "@/assets/iconfont/iconfont.css"
import "@/assets/css/common.css"
import '@/utils/rem.js';
import plugins from "@/components/index.js";
import utils from "./utils/utils";

Vue.config.productionTip = false
Vue.prototype.$utils = utils;
console.log(utils)

Vue.use(plugins);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
